import Card from './card';
import DL, { DLItem } from './definition-list';
import Divider from './divider';
import CardInput from './payment-summary-card-input';

export default function PaymentSummary<Amount extends { display: string }>({
  amount,
  headline = 'Payment Summary',
  label,
}: {
  amount: Amount;
  headline?: string;
  label: string;
}) {
  return (
    <Card headline={headline}>
      <DL>
        <DLItem variant="lg" label={label} value={amount.display} />
      </DL>
      <Divider />
      <CardInput />
    </Card>
  );
}
